import { Dropdown, Menu, Tooltip } from 'antd';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import './FilterDropdown.css';
import _ from 'underscore';

const FilterDropdown = ({
  history,
  setTempSelectedCategory,
  handleEditCategory,
  handleDeleteCategory,
  categories,
  modalOpen,
  handleSetPlaylist,
  tempSelectedCategory,
  handleNew,
  filter,
  title,
  isAdsum,
}) => {
  const { role } = useSelector(
    (state) => ({
      role: state.auth.userData.role,
    }),
    shallowEqual
  );
  return (
    <div
      className={`playlist-dropdown ${
        modalOpen ? 'playlist-dropdown-open' : 'playlist-dropdown-closed'
      }`}
      onClick={(e) => e.stopPropagation()}
    >
      <ul className="filter-dropdown">
        {role === 'superadmin' && handleNew && (
          <li className="header" onClick={handleNew}>
            <i className="feather-plus" />
            {`Add New ${title ?? 'Category'}`}
          </li>
        )}
        {filter && (
          <li>
            <div
              className={`radio ${
                tempSelectedCategory.length === categories.length
                  ? 'active'
                  : ''
              }`}
              onClick={() => setTempSelectedCategory('all')}
            >
              {tempSelectedCategory.length === categories.length && (
                <div className="radio-checked" />
              )}
            </div>
            {tempSelectedCategory.length === categories.length
              ? 'Unselect All'
              : 'Select All'}
          </li>
        )}

        {_.sortBy(categories, 'name').map((cat) => {
          return (
            <li key={cat._id}>
              <div className="playlist-filter">
                <div className="playlist-filter-radio">
                  <div
                    className={`radio ${
                      tempSelectedCategory === cat._id ? 'active' : ''
                    }`}
                    onClick={() =>
                      setTempSelectedCategory(
                        isAdsum ? cat.adsumScreenId : cat._id
                      )
                    }
                  >
                    {tempSelectedCategory.find(
                      (temp) => temp === (isAdsum ? cat.adsumScreenId : cat._id)
                    ) && <div className="radio-checked" />}
                  </div>
                  {cat.name}
                </div>
                {handleEditCategory &&
                  handleDeleteCategory &&
                  role === 'superadmin' && (
                    <Tooltip title="Options">
                      <Dropdown
                        trigger="click"
                        overlay={
                          <Menu>
                            <Menu.Item
                              key="edit"
                              onClick={() => handleEditCategory(cat)}
                            >
                              <i className="feather-edit mr-2" />
                              Edit
                            </Menu.Item>
                            <Menu.Divider />
                            <Menu.Item
                              key="delete"
                              onClick={() => handleDeleteCategory(cat)}
                            >
                              <i className="feather-trash-2 mr-2" />
                              Delete
                            </Menu.Item>
                          </Menu>
                        }
                      >
                        <button>
                          <i className="feather-more-horizontal" />
                        </button>
                      </Dropdown>
                    </Tooltip>
                  )}
              </div>
            </li>
          );
        })}
        <li className="playlist-button" onClick={handleSetPlaylist}>
          {`Set ${title ?? 'Category'}`}
        </li>
      </ul>
    </div>
  );
};

export default FilterDropdown;
